"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuideButtonCategoryType = void 0;
var GuideButtonCategoryType;
(function (GuideButtonCategoryType) {
    GuideButtonCategoryType["GAMES"] = "GAMES";
    GuideButtonCategoryType["GAME_CENTER"] = "GAME_CENTER";
    GuideButtonCategoryType["GAMIFICATION"] = "GAMIFICATION";
    GuideButtonCategoryType["LINKS"] = "LINKS";
    GuideButtonCategoryType["ANALYTICS"] = "ANALYTICS";
    GuideButtonCategoryType["USER_BASE"] = "USER_BASE";
    GuideButtonCategoryType["ACCOUNT_PAGES"] = "ACCOUNT_PAGES";
    GuideButtonCategoryType["MANAGE_USERS"] = "MANAGE_USERS";
    GuideButtonCategoryType["MANAGE_BRANDS"] = "MANAGE_BRANDS";
    GuideButtonCategoryType["BRAND_ASSETS"] = "BRAND_ASSETS";
    GuideButtonCategoryType["DATA_INTEGRATION"] = "DATA_INTEGRATION";
    GuideButtonCategoryType["RECEIPT"] = "RECEIPT";
})(GuideButtonCategoryType || (exports.GuideButtonCategoryType = GuideButtonCategoryType = {}));
